import { render, staticRenderFns } from "./OwnClassTimeTable.vue?vue&type=template&id=0bea22fb&scoped=true&"
import script from "./OwnClassTimeTable.vue?vue&type=script&lang=js&"
export * from "./OwnClassTimeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea22fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
